// AgGridHeadersSearch — hidden sortBy widget for AG Grid column sorting
window.AgGridHeadersSearch = {
  _prefix: null,
  _env: null,
  _widget: null,
  _defaultIndex: null,

  _projectIndexObjMap(field, order) {
    return {
      value: this._projectIndexNameMap(field, order),
      label: ''
    };
  },

  _projectIndexNameMap(field, order) {
    return _.compact([this._prefix, `projects_by_${field}_${order}`, this._env]).join('_');
  },

  _startingIndexes() {
    return _.map([
      ['title', 'desc'],
      ['title', 'asc'],
      ['ended_at', 'desc'],
      ['ended_at', 'asc'],
      ['updated_at', 'desc'],
      ['updated_at', 'asc'],
      ['status', 'asc'],
      ['status', 'desc'],
      ['budget', 'asc'],
      ['budget', 'desc'],
      ['number_of_participants', 'asc'],
      ['number_of_participants', 'desc']
    ], x => this._projectIndexObjMap(x[0], x[1]));
  },

  _initWidget() {
    const el = document.createElement('div');
    el.id = 'sort-by-container';
    el.style.display = 'none';
    $('#projects-index-table, #projects-search-result').append(el);

    const indices = this._startingIndexes();
    indices.push({ value: this._defaultIndex, label: '' });

    return instantsearch.widgets.sortBy({
      container: '#sort-by-container',
      items: indices
    });
  },

  initializeHiddenSearchWidget(prefix, defaultIndex, env) {
    this._defaultIndex = defaultIndex;
    this._prefix = prefix;
    this._env = env;
    this._widget = this._initWidget();

    return this._widget;
  },

  setDefaultIndex() {
    // IS v4: sortBy widget no longer exposes setIndex directly.
    // Trigger a refinement via the helper instead.
    try {
      const helper = (PublicProjectsSearch._searchObject || {}).helper;
      if (helper) {
        helper.setIndex(this._defaultIndex).search();
      }
    } catch (e) {
      console.warn('[AgGridHeadersSearch] setDefaultIndex failed:', e.message);
    }
  },

  setIndex(field, order) {
    const indexName = this._projectIndexNameMap(field, order);
    try {
      const helper = (PublicProjectsSearch._searchObject || {}).helper;
      if (helper) {
        helper.setIndex(indexName).search();
      }
    } catch (e) {
      console.warn('[AgGridHeadersSearch] setIndex failed:', e.message);
    }
  }
};